<div *ngIf="roles">
  <nav class="navbar navbar-light navbar-expand-lg p-3" [ngStyle]="{ 'border-bottom-color': getUserColor() }" *ngIf="navigationStructure$ | async">
    <div id="overlaywrapper" #overlaywrapper style="display: none">
      <div id="overlay"></div>
      <div id="close">
        <a>
          <img src="../../../../../../../../../PerfNav/img/close.png" width="30" height="30" border="0" />
        </a>
      </div>
      <div id="overlayContent">
        <iframe id="learningPlan" #learningPlan name="learningPlan" frameborder="0" width="100%" height="100%" scrolling="auto" src=""></iframe>
      </div>
    </div>
    <div class="navbar-collapse collapse" id="navbarSupportedContent" [ngClass]="{ show: isOpen }">
      <form class="d-flex flex-row align-items-center flex-wrap my-2 my-lg-0 ms-auto" (submit)="$event.preventDefault()">
        <a class="navbar-brand mx-auto p-0" [routerLink]="[home.getAngularUrl()]">
          <div class="logo"></div>
        </a>

        <ng-container *ngIf="showFavourites">
          <ng-container *ngIf="!sortFavoriteMode">
            <ng-container *ngIf="favourites && favourites.length">
              <button *ngIf="favourites.length > 1" type="button" class="cursor-pointer position-relative me-3" [ngbTooltip]="'change_sortorder_favourites' | label : 'navigation' | async" container="body" (click)="startSortingFavorites()">
                <i class="fas fa-cog"></i>
              </button>
              <ng-container *ngFor="let favourite of favourites; let i = index; let last = last">
                <button type="button" class="cursor-pointer position-relative" aria-expanded="false" (click)="clickFavourite(favourite.menuItem)" [ngbTooltip]="favourite.label" placement="top" container="body" [ngStyle]="{ 'margin-right': last ? '80px' : '0' }" [ngClass]="{ active: favourite.isActive }">
                  <i class="far fa-bookmark"></i>
                  <span class="favourite-number">{{ i + 1 }}</span>
                </button>
                <div class="seperator me-2 ms-2 sep-menu" *ngIf="!last">|</div>
              </ng-container>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="sortFavoriteMode">
            <ng-container *ngIf="favourites && favourites.length">
              <button *ngIf="favourites.length > 1" type="button" class="cursor-pointer position-relative me-3" [ngbTooltip]="'ready_sorting_favourites' | label : 'navigation' | async" container="body" (click)="stopSortingFavorites()">
                <i class="fas fa-check text-success"></i>
              </button>
              <div cdkDropList cdkDropListOrientation="horizontal" class="align-items-center d-flex favorites-sorting" style="margin-right: 63px" (cdkDropListDropped)="dropFavorite($event)">
                <ng-container *ngFor="let favourite of favourites; let i = index; let last = last">
                  <div cdkDrag cdkDragLockAxis="x" class="d-flex flex-row me-4 favorite-sorting" [ngbTooltip]="favourite.label" placement="top" container="body">
                    <div class="position-relative" style="font-size: 1.6em">
                      <i class="far fa-bookmark"></i>
                      <span class="favourite-number">{{ i + 1 }}</span>
                    </div>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="settings && settingsLoaded">
          <ng-container *ngFor="let setting of settings">
            <ng-container [ngSwitch]="setting.name">
              <ng-container *ngSwitchCase="'show_tasks'">
                <ng-container *ngIf="roles.level != Roles.LocalHr">
                  <div class="dropdown" [class.open]="taskListOpen" id="taskDrop" (mouseover)="taskListOpen = true" (mouseout)="taskListOpen = false">
                    <button class="dropdown-toggle" type="button" id="dropdownMenuButtonTasks" [routerLink]="['/framework/ess/tasks']" [ngClass]="{ active: activeMenuItem && activeMenuItem.getAngularUrl() == '/framework/ess/tasks' }" *ngIf="widgetTasks">
                      <!-- <i class="fa fa-envelope" aria-hidden="true"></i> -->
                      <div *ngIf="widgetTasks.customIcon; else checkCustomIcon" [innerHTML]="widgetTasks.customIcon | safeHTML" class="custom-svg"></div>

                      <ng-template #checkCustomIcon>
                        <img *ngIf="widgetTasks.customCssIcon" [src]="widgetTasks.customCssIcon" class="custom-img" />
                        <i *ngIf="!widgetTasks.customCssIcon" [ngClass]="[widgetTasks.cssIcon]" class=""></i>
                      </ng-template>
                      <span class="badge badge-warning statusOngoing background">
                        {{ taskLength }}
                      </span>
                    </button>
                    <div *ngIf="taskOverview$ | async" class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButtonTasks">
                      <div class="dropdown-item cursor-pointer" *ngFor="let task of tasks" (click)="navigateToTaskDetail(task)">
                        <ng-container *ngIf="!task.studentId">
                          <div class="profilePicture" *ngIf="task.profilePictureId">
                            <app-circle-image *ngIf="task.profilePictureId > 0" [photo]="task.profilePicture" [width]="25"> </app-circle-image>
                          </div>

                          <ng-container *ngIf="!task.profilePictureId">
                            <div class="task-icon">
                              <i *ngIf="task.category == TaskCategories.CourseConfirm || task.category == TaskCategories.CourseConfirmTeam || task.category == TaskCategories.CourseEval || task.category == TaskCategories.CourseEvalTeam || task.category == TaskCategories.CourseGroupTeam || task.category == TaskCategories.CourseRequest || task.category == TaskCategories.CourseRequestStatusChange || task.category == TaskCategories.PlannedCourseDays" class="fas fa-users icon"></i>
                              <i *ngIf="task.category == TaskCategories.Elearning" class="fas fa-desktop icon"></i>
                              <i *ngIf="task.category == TaskCategories.LearningPath" class="fas fa-tasks icon"></i>
                              <i *ngIf="task.category == TaskCategories.LearningPathCourseReEnter" class="fas fa-tasks icon"></i>
                            </div>
                          </ng-container>
                        </ng-container>

                        <ng-container *ngIf="task.studentId">
                          <div class="me-2">
                            <div class="float-start me-4">
                              <app-profile-picture [whoId]="task.studentId" [whoKind]="3" [width]="25" [text]="task.studentName"> </app-profile-picture>
                            </div>
                          </div>
                        </ng-container>

                        <div class="roleDescription">
                          <h1 class="text-truncate">
                            {{ task.name }}
                            <small *ngIf="task.startDate && task.category != TaskCategories.CourseEval">
                              {{ task.startDate | employeeDate | async }}
                            </small>
                          </h1>
                          <p class="text-truncate">
                            {{ task.description }}
                          </p>
                        </div>
                      </div>
                      <a class="dropdown-item dropdown-link pt-3 pb-3" [routerLink]="['/framework/ess/tasks']">
                        {{ 'widget_showall' | label : 'tasks' | async }}
                        ({{ taskLength || '...' }}).
                      </a>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="roles.level == Roles.LocalHr">
                  <div class="dropdown" [class.open]="taskListOpen" id="taskDrop" (mouseover)="taskListOpen = true" (mouseout)="taskListOpen = false">
                    <button class="dropdown-toggle" type="button" id="dropdownMenuButtonTasks" [routerLink]="['/framework/tasks/localhr-tasks']" [ngClass]="{ active: activeMenuItem && activeMenuItem.getAngularUrl() == '/framework/tasks/localhr-tasks' }" *ngIf="widgetTasks">
                      <!-- <i class="fa fa-envelope" aria-hidden="true"></i> -->
                      <div *ngIf="widgetTasks.customIcon; else checkCustomIcon" [innerHTML]="widgetTasks.customIcon | safeHTML" class="custom-svg"></div>

                      <ng-template #checkCustomIcon>
                        <img *ngIf="widgetTasks.customCssIcon" [src]="widgetTasks.customCssIcon" class="custom-img" />
                        <i *ngIf="!widgetTasks.customCssIcon" [ngClass]="[widgetTasks.cssIcon]" class=""></i>
                      </ng-template>
                      <span class="badge badge-warning statusOngoing background">
                        {{ taskLength }}
                      </span>
                    </button>
                    <div *ngIf="taskOverview$ | async" class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButtonTasks">
                      <div class="dropdown-item cursor-pointer" *ngFor="let task of tasks" (click)="navigateToTaskDetail(task)">
                        <ng-container *ngIf="!task.studentId">
                          <div class="profilePicture" *ngIf="task.profilePictureId">
                            <app-circle-image *ngIf="task.profilePictureId > 0" [photo]="task.profilePicture" [width]="25"> </app-circle-image>
                          </div>

                          <ng-container *ngIf="!task.profilePictureId">
                            <div class="task-icon">
                              <i *ngIf="task.category == TaskCategories.CourseConfirm || task.category == TaskCategories.CourseConfirmTeam || task.category == TaskCategories.CourseEval || task.category == TaskCategories.CourseEvalTeam || task.category == TaskCategories.CourseGroupTeam || task.category == TaskCategories.CourseRequest || task.category == TaskCategories.CourseRequestStatusChange || task.category == TaskCategories.PlannedCourseDays" class="fas fa-users icon"></i>
                              <i *ngIf="task.category == TaskCategories.Elearning" class="fas fa-desktop icon"></i>
                              <i *ngIf="task.category == TaskCategories.LearningPath" class="fas fa-tasks icon"></i>
                              <i *ngIf="task.category == TaskCategories.LearningPathCourseReEnter" class="fas fa-tasks icon"></i>
                            </div>
                          </ng-container>
                        </ng-container>

                        <ng-container *ngIf="task.studentId">
                          <div class="me-2">
                            <div class="float-start me-4">
                              <app-profile-picture [whoId]="task.studentId" [whoKind]="3" [width]="25" [text]="task.studentName"> </app-profile-picture>
                            </div>
                          </div>
                        </ng-container>

                        <div class="roleDescription">
                          <h1 class="text-truncate">
                            {{ task.name }}
                            <small *ngIf="task.startDate && task.category != TaskCategories.CourseEval">
                              {{ task.startDate | employeeDate | async }}
                            </small>
                          </h1>
                          <p class="text-truncate">
                            {{ task.description }}
                          </p>
                        </div>
                      </div>
                      <a class="dropdown-item dropdown-link pt-3 pb-3" [routerLink]="['/framework/tasks/localhr-tasks']">
                        {{ 'widget_showall' | label : 'tasks' | async }}
                        ({{ taskLength || '...' }}).
                      </a>
                    </div>
                  </div>
                </ng-container>

                <div class="seperator me-2 ms-2">|</div>
              </ng-container>
              <ng-container *ngSwitchCase="'show_timeline'">
                <button class="cursor-pointer" type="button" title="{{ 'timeline' | label : 'navigation' | async }}" (click)="navigatetotimeline()" [ngClass]="{ active: activeMenuItem && activeMenuItem.getAngularUrl() == getTimeLineUrl() }">
                  <i class="far fa-chart-bar"></i>
                </button>
                <div class="seperator me-2 ms-2 sep-timel">|</div>
              </ng-container>
              <ng-container *ngSwitchCase="'show_print'">
                <button class="cursor-pointer" type="button" title="{{ 'printthispage' | label : 'navigation' | async }}" (click)="print()">
                  <i class="fas fa-print"></i>
                </button>
                <div class="seperator me-2 ms-2 sep-print">|</div>
              </ng-container>
              <ng-container *ngSwitchCase="'show_search'">
                <input #whoIsWhoSearchInput aria-label="Search" class="form-control form-control-line w-auto" placeholder="{{ 'searchlabelWhoiswho' | label : 'topnavigation' | async }}" type="search" (keyup.enter)="navigatetowhoiswho()" />
                <div class="seperator me-2 ms-2 sep-who">|</div>
              </ng-container>
              <ng-container *ngSwitchCase="'show_blackboard'">
                <ng-container *ngIf="whoKind == 3 && widgetBlackboard">
                  <ng-container *ngIf="messages$ | async">
                    <div class="dropdown" id="notificationDrop">
                      <button class="dropdown-toggle" type="button" id="dropdownMenuButtonNotifications" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" [routerLink]="['framework/blackboard/archive-employee']" [ngClass]="{ active: activeMenuItem && activeMenuItem.getAngularUrl() == '/framework/blackboard/archive-employee' }">
                        <!-- <i class="fas fa-bell" aria-hidden="true"></i> -->
                        <div *ngIf="widgetBlackboard.customIcon; else checkCustomIcon" [innerHTML]="widgetBlackboard.customIcon | safeHTML" class=""></div>

                        <ng-template #checkCustomIcon>
                          <img *ngIf="widgetBlackboard.customCssIcon" [src]="widgetBlackboard.customCssIcon" class="custom-img" />
                          <i *ngIf="!widgetBlackboard.customCssIcon" [ngClass]="[widgetBlackboard.cssIcon]" class=""></i>
                        </ng-template>

                        <span class="badge badge-warning statusOngoing background" *ngIf="messageLength > 0">
                          {{ messageLength }}
                        </span>
                      </button>
                      <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButtonNotifications">
                        <div (click)="navigateToArchives()">
                          <!-- <a class="dropdown-item" *ngFor="let message of messages">
                            <div class="profilePicture">
                              <app-circle-image [photo]="message.photo" [width]="25"></app-circle-image>
                            </div>
                            <div class="roleDescription">
                              <h1 class="text-truncate">
                                {{ message.subject }}
                                <small>{{ message.postedDate | employeeDate | async }}</small>
                              </h1>
                              <p class="text-truncate">{{ message.body }}</p>
                            </div>
                          </a> -->
                        </div>
                        <div>
                          <a class="dropdown-item dropdown-link pt-3 pb-3" [routerLink]="['framework/blackboard/archive-employee']">
                            {{ 'widget_showall' | label : 'blackboard' | async }}
                          </a>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <div class="seperator me-2 ms-2">|</div>
                </ng-container>
                <ng-container *ngIf="whoKind != 3 && widgetBlackboard">
                  <ng-container *ngIf="setting.menuItem && setting.menuItem.getAngularUrl() && setting.menuItem.cssClass">
                    <button type="button" class="cursor-pointer" aria-expanded="false" [routerLink]="[setting.menuItem.getAngularUrl()]" [title]="setting.menuItem.label" [ngClass]="{ active: activeMenuItem && activeMenuItem.getAngularUrl() == setting.menuItem.getAngularUrl() }">
                      <!-- <i class="fa" [ngClass]="setting.menuItem.cssClass" aria-hidden="true"></i> -->
                      <div *ngIf="widgetBlackboard.customIcon; else checkCustomIcon" [innerHTML]="widgetBlackboard.customIcon | safeHTML" class="custom-svg"></div>

                      <ng-template #checkCustomIcon>
                        <img *ngIf="widgetBlackboard.customCssIcon" [src]="widgetBlackboard.customCssIcon" class="custom-img" />
                        <i *ngIf="!widgetBlackboard.customCssIcon" [ngClass]="[widgetBlackboard.cssIcon]" class=""></i>
                      </ng-template>
                    </button>
                    <div class="seperator me-2 ms-2 sep-menu">|</div>
                  </ng-container>
                </ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="'show_notifications'">
                <button type="button" title="{{ 'show_notifications' | label : 'home_setting' | async }}" [routerLink]="['framework/blackboard/archive-employee']" [ngClass]="{ active: activeMenuItem && activeMenuItem.getAngularUrl() == '/framework/blackboard/archive-employee' }" *ngIf="widgetBlackboard">
                  <!-- <i class="fas fa-bell" aria-hidden="true"></i> -->
                  <div *ngIf="widgetBlackboard.customIcon; else checkCustomIcon" [innerHTML]="widgetBlackboard.customIcon | safeHTML" class="custom-svg"></div>

                  <ng-template #checkCustomIcon>
                    <img *ngIf="widgetBlackboard.customCssIcon" [src]="widgetBlackboard.customCssIcon" class="custom-img" />
                    <i *ngIf="!widgetBlackboard.customCssIcon" [ngClass]="[widgetBlackboard.cssIcon]" class=""></i>
                  </ng-template>
                </button>
                <div class="seperator me-2 ms-2">|</div>
              </ng-container>
              <ng-container *ngSwitchCase="'show_employees'">
                <ng-container *ngIf="employeeFischeMenuItem$ | async as menuItem">
                  <input *ngIf="menuItem" #employeeSearchInput aria-label="Search" class="form-control form-control-line w-auto" placeholder="{{ 'employee' | label : 'navigation' | async }}" type="search" (keyup.enter)="navigateToStudent()" />
                  <div class="seperator me-2 ms-2 sep-who">|</div>
                </ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="'show_searchresults'">
                <input #searchInputCompany aria-label="Search" class="form-control form-control-line w-auto" placeholder="{{ 'company' | label : 'navigation' | async }}" type="search" (keyup.enter)="navigateToCompany()" />
                <div class="seperator me-2 ms-2 sep-who">|</div>
              </ng-container>
              <ng-container *ngSwitchCase="'show_tickettool'">
                <ng-container *ngIf="serviceDeskUrl != ''">
                  <button class="cursor-pointer" type="button" title="{{ 'mailhelpdesk' | label : 'navigation' | async }}" (click)="sendMailToServicedesk()" style="color: #555">
                    <i class="fa fa-envelope"></i>
                  </button>
                  <div class="seperator me-2 ms-2 sep-timel">|</div>
                </ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="'show_online_users'">
                <button class="cursor-pointer" type="button" title="{{ 'onlineusers' | label : 'navigation' | async }}" (click)="navigateToActivelist()" style="color: #555">
                  <i class="fa fa-user"></i>
                </button>
                <div class="seperator me-2 ms-2 sep-timel">|</div>
              </ng-container>

              <ng-container *ngSwitchDefault>
                <ng-container *ngIf="setting.menuItem && setting.menuItem.getAngularUrl() && setting.menuItem.cssClass">
                  <button type="button" class="cursor-pointer" aria-expanded="false" (click)="clickFavourite(setting.menuItem)" [title]="setting.menuItem.label" [ngClass]="{ active: activeMenuItem && activeMenuItem.getAngularUrl() == setting.menuItem.getAngularUrl() }">
                    <!-- <i class="fa" [ngClass]="setting.menuItem.cssClass" aria-hidden="true"></i> -->
                    <div *ngIf="setting.menuItem.customIcon; else checkCustomIcon" [innerHTML]="setting.menuItem.customIcon | safeHTML" class="custom-svg"></div>

                    <ng-template #checkCustomIcon>
                      <img *ngIf="setting.menuItem.customCssIcon" [src]="setting.menuItem.customCssIcon" class="custom-img" />
                      <i *ngIf="!setting.menuItem.customCssIcon" [ngClass]="[setting.menuItem.cssIcon]" class="fa"></i>
                    </ng-template>
                  </button>
                  <div class="seperator me-2 ms-2 sep-menu">|</div>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>

        <!-- ---------- ---------- ---------- ---------- ---------- --------- -->
        <!-- ----------   ---------- PROFILE DROPDOWN ---------- ----------  -->
        <div class="profile" *ngIf="currentEmployee$ | async as currentEmployee">
          <div ngbDropdown class="d-inline-block" id="profileDrop">
            <button type="button" id="dropdownMenuButtonProfile" ngbDropdownToggle aria-haspopup="true" aria-expanded="false">
              {{ currentEmployee.firstName + ' ' + currentEmployee.lastName }}
            </button>

            <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButtonProfile">
              <app-role-dropdown></app-role-dropdown>
            </div>
          </div>

          <ng-container *ngIf="myProfileMenuItem$ | async as myProfileMenuItem; else profilepictureneeded">
            <div *ngIf="myProfileMenuItem; else profilepictureneeded" class="profilePicture ms-2 me-2 mainProfile cursor-pointer no-bg" [routerLink]="[myProfileMenuItem.getAngularUrl()]" [queryParams]="{ item: whoKind == 1 ? roles.corporateHrId : whoKind == 2 ? roles.localHrId : 0 }" [title]="myProfileMenuItem.label">
              <app-profile-picture [text]="currentEmployee.firstName + ' ' + currentEmployee.lastName" [whoKind]="whoKind" [whoId]="currentEmployee.studentId"> </app-profile-picture>
            </div>
          </ng-container>
          <ng-template #profilepictureneeded>
            <div class="profilePicture ms-2 me-2 mainProfile no-bg" style="cursor: default !important">
              <app-profile-picture [text]="currentEmployee.firstName + ' ' + currentEmployee.lastName" [whoKind]="whoKind" [whoId]="currentEmployee.studentId"> </app-profile-picture>
            </div>
          </ng-template>
        </div>
      </form>
    </div>

    <img src="/progreso/assets/images/logo.png" class="d-block d-sm-block d-md-block d-lg-none" [routerLink]="[home.getAngularUrl()]" />

    <button class="navbar-toggler d-lg-none d-xl-none" (click)="openNav()" id="openPersonalNav">
      <span class="navbar-toggler-icon"></span>
    </button>
    <button class="navbar-toggler d-lg-none d-xl-none" (click)="closeNav()" id="closePersonalNav"></button>

    <div id="personalNav" class="overlay d-lg-none d-xl-none">
      <div class="overlay-content">
        <div class="row">
          <div class="col-6 navigationDivider">
            <a class="p-3" (click)="showMainNav()" id="mainNavBtn"> Navigatie </a>
          </div>
          <div class="col-6 navigationDivider">
            <a class="p-3" (click)="showExtraNav()" id="extraNavBtn"> Selecteer je rol </a>
          </div>
        </div>
        <div id="moduleNavigation">
          <div class="row ps-3 module" routerLinkActive="currentModule" *ngFor="let item of home.subPages">
            <a [routerLink]="[item.getAngularUrl()]" (click)="closeNav()" class="pt-3 ps-3 pe-3">
              <h1>{{ item.label }}</h1>
            </a>
          </div>
        </div>
        <div id="extraNavigation">
          <div class="role row p-3 mt-3 ps-3 justify-content-center">
            <app-role-dropdown></app-role-dropdown>
          </div>
        </div>
      </div>
    </div>
  </nav>
</div>

<ng-template #modalcontent let-modal>
  <div>
    <div class="modal-header">
      <h5 class="modal-title">
        {{ 'choose-company' | label : 'company-selection' | async }}
      </h5>
      <button type="button" class="btn-close" aria-label="close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body" style="overflow: initial; max-height: initial">
      <ul>
        <li *ngFor="let company of companies" (click)="modal.close(company.id)">
          <a>{{ company.name }}</a>
        </li>
      </ul>
    </div>
  </div>
</ng-template>
